export default __webpack_public_path__ + "static/media/aboutme.91af6e77.png";